import { Passwordless } from 'amazon-cognito-passwordless-auth';

const amplifyStoragePrefix = 'CognitoIdentityServiceProvider';
const customStoragePrefix = 'Passwordless';

/** Removes every storage key a signed-in session occupies. Resolves once done. */
export async function clearStoredTokens(): Promise<void> {
  const { clientId, storage } = Passwordless.configure();

  const lastAuthUserKey = `${amplifyStoragePrefix}.${clientId}.LastAuthUser`;
  const username = await storage.getItem(lastAuthUserKey);

  if (!username) {
    return;
  }

  await Promise.all([
    storage.removeItem(lastAuthUserKey),
    storage.removeItem(`${amplifyStoragePrefix}.${clientId}.${username}.idToken`),
    storage.removeItem(`${amplifyStoragePrefix}.${clientId}.${username}.accessToken`),
    storage.removeItem(`${amplifyStoragePrefix}.${clientId}.${username}.refreshToken`),
    // The vendor SDK's own storeTokens() (amazon-cognito-passwordless-auth's
    // dist/client/storage.js) writes these two alongside the four above:
    // userData carries the user's sub and email (genuine PII), and
    // tokenScopesString the granted OAuth scopes. Both become unreachable via
    // this package's normal read path once LastAuthUser is gone, but that
    // just means nothing else will ever clean them up either, so they must
    // be removed here.
    storage.removeItem(`${amplifyStoragePrefix}.${clientId}.${username}.userData`),
    storage.removeItem(`${amplifyStoragePrefix}.${clientId}.${username}.tokenScopesString`),
    storage.removeItem(`${customStoragePrefix}.${clientId}.${username}.expireAt`),
  ]);
}
